// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"70":"80a20c2c","934":"c0c52f47"}[chunkId] + ".chunk.js");